import {
    Box,
    createStyles,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    Theme,
    Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { useIntl } from "react-intl";
import { useGetSensorModelStocksByTypeQuery } from "../../../graphql/generated/graphql";
import { SensorType } from "../../Sensor/SensorWrapper";
import messages from "../messages";
import AssemblyList from "./AssemblyList";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        panel: {
            borderBottom: `1px solid ${theme.palette.grey["300"]}`,
        },
        summary: {
            paddingLeft: 0,
            paddingRight: theme.spacing(1),
        },
        expandedSummary: {
            minHeight: 0,
            marginTop: 0,
            marginBottom: 0,
        },
        details: {
            padding: `0 0 ${theme.spacing(2)} 0`,
        },
        heading: {
            fontSize: theme.typography.pxToRem(15),
            fontWeight: theme.typography.fontWeightRegular,
        },
    })
);

const AssemblyWrapper: React.FC = () => {
    const classes = useStyles();

    const {
        data: sensorModelsData,
        loading: sensorModelsLoading,
        error: sensorModelsError,
    } = useGetSensorModelStocksByTypeQuery({
        variables: {
            typeIds: [SensorType.ASSEMBLY],
        },
        fetchPolicy: "cache-and-network",
    });

    // translations
    const intl = useIntl();
    const transAssemblyWrapper = intl.formatMessage({ ...messages.assemblyPanel });

    return (
        <Box className={classes.root}>
            <ExpansionPanel square elevation={0} className={classes.panel}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="assemblies-panel"
                    id="assemblies-header"
                    classes={{ root: classes.summary, expanded: classes.expandedSummary }}
                >
                    <Typography className={classes.heading}>{transAssemblyWrapper}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails classes={{ root: classes.details }}>
                    <AssemblyList data={sensorModelsData} loading={sensorModelsLoading} error={sensorModelsError} />
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </Box>
    );
};

export default AssemblyWrapper;
